const VAR_MAP = {
  brand: '--brand',
  surface1: '--surface-1',
  backgroundColor: '--background-color',
  slate12: '--slate-12',
  slate11: '--slate-11',
  slate10: '--slate-10',
  slate4: '--slate-4',
  alpha1: '--alpha-1',
  alpha2: '--alpha-2',
};

const DEFAULT_THEME = {
  light: {
    brand: '7 96 83',
    surface1: '242 243 246',
    backgroundColor: '255 255 255',
    slate12: '40 40 40',
    slate11: '88 90 90',
    slate10: '20 20 20',
    slate4: '0 0 0',
    alpha1: '223, 241, 239',
    alpha2: '223, 241, 239',
  },
  dark: {
    brand: '11 142 123',
    surface1: '20 21 23',
    backgroundColor: '17 17 19',
    slate12: '237 238 240',
    slate11: '176 180 186',
    slate10: '119 123 132',
    slate4: '39 42 45',
    alpha1: '4, 42, 36',
    alpha2: '4, 42, 36',
  },
};

export const rgbToHex = (r, g, b) => {
  const toHex = n => {
    const h = Math.max(0, Math.min(255, Math.round(n))).toString(16);
    return h.length === 1 ? `0${h}` : h;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`
    : null;
};

export const parseRgbValue = val => {
  if (!val || typeof val !== 'string') return null;
  const space = val.match(/^(\d+)\s+(\d+)\s+(\d+)$/);
  if (space) return { r: +space[1], g: +space[2], b: +space[3], a: 1 };
  const comma = val.match(/^(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?$/);
  if (comma)
    return {
      r: +comma[1],
      g: +comma[2],
      b: +comma[3],
      a: comma[4] != null ? +comma[4] : 1,
    };
  return null;
};

export const parseRgbaValue = val => {
  if (!val || typeof val !== 'string') return null;
  const m = val.match(/^(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?$/);
  if (m) return { r: +m[1], g: +m[2], b: +m[3], a: m[4] != null ? +m[4] : 1 };
  return null;
};

export const rgbaToStored = (r, g, b, a) => {
  if (a >= 0.999) return `${r}, ${g}, ${b}`;
  return `${r}, ${g}, ${b}, ${a}`;
};

const buildCssVars = modeVars => {
  return Object.entries(VAR_MAP)
    .filter(([key]) => modeVars[key] != null)
    .map(([key, cssVar]) => `${cssVar}: ${modeVars[key]};`)
    .join('\n    ');
};

const applyThemeToStyle = (theme, styleEl) => {
  const lightVars = buildCssVars(theme.light || DEFAULT_THEME.light);
  const darkVars = buildCssVars(theme.dark || DEFAULT_THEME.dark);
  styleEl.textContent = `
  :root {
    ${lightVars}
  }
  .dark {
    ${darkVars}
  }
`;
};

export const applyTheme = themeConfig => {
  const theme =
    typeof themeConfig === 'string'
      ? (() => {
          try {
            return JSON.parse(themeConfig);
          } catch {
            return DEFAULT_THEME;
          }
        })()
      : themeConfig || DEFAULT_THEME;

  let styleEl = document.getElementById('theme-colors-custom');
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = 'theme-colors-custom';
    document.head.appendChild(styleEl);
  }
  applyThemeToStyle(theme, styleEl);
};

export const useTheme = () => {
  const initTheme = () => {
    const themeConfig = window.globalConfig?.THEME_COLORS;
    if (themeConfig) {
      applyTheme(themeConfig);
    }
  };

  return { applyTheme, initTheme, DEFAULT_THEME, VAR_MAP };
};
